import { gql } from "@apollo/client";


export const GET_LEVEL_SECTION_PAGINATION = gql`
    query GetLevelSectionPagination($page: Int, $limit: Int, $pagination: Boolean, $keyword: String, $isUse: Boolean) {
        getLevelSectionPagination(page: $page, limit: $limit, pagination: $pagination, keyword: $keyword, isUse: $isUse) {
            data {
                _id
                levelSectionKhName
                levelSectionEnName
                isUse
                remark
            }
            paginator {
                slNo
                prev
                next
                perPage
                totalPosts
                totalPages
                currentPage
                hasPrevPage
                hasNextPage
                totalDocs
            }
        }
    }
`;




export const UPDATE_LEVEL_SECTION_IS_USE = gql`
mutation UpdateLevelSectionIsUse($id: ID!, $isUse: Boolean) {
  updateLevelSectionIsUse(_id: $id, isUse: $isUse) {
    status
    message {
      messageEn
      messageKh
    }
  }
}
`;


export const CREATE_LEVEL_SECTION = gql`
    mutation CreateLevelSection($input: LevelSectionInput) {
        createLevelSection(input: $input) {
            message {
                messageKh
                messageEn
            }
            status
        }
    }
`;


export const UPDATE_LEVEL_SECTION = gql`
    mutation UpdateLevelSection($id: ID!, $input: LevelSectionInput) {
        updateLevelSection(_id: $id, input: $input) {
            message {
                messageEn
                messageKh
            }
            status
        }
    }
`;


export const DELETE_LEVEL_SECTION = gql`
    mutation DeleteLevelSection($id: ID!) {
        deleteLevelSection(_id: $id) {
            status
            message {
                messageEn
                messageKh
            }
        }
    }
`


